import { render, staticRenderFns } from "./Main_menuComputer.vue?vue&type=template&id=f5d232ea&scoped=true"
import script from "./Main_menuComputer.vue?vue&type=script&lang=js"
export * from "./Main_menuComputer.vue?vue&type=script&lang=js"
import style1 from "./Main_menuComputer.vue?vue&type=style&index=1&id=f5d232ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d232ea",
  null
  
)

export default component.exports